import React, { useEffect, useState } from "react";
import { getAppFAQs } from '../../api/apiHandler';
import { showErrorMessage } from "../common/Utils";

export function FAQs() {

    // Styling for components
    const styles = {
        pageContainer: {
            fontFamily: "'Arial', sans-serif",
            background: 'linear-gradient(135deg, rgba(234, 225, 199, 1) 0%, rgba(173, 163, 129, 1) 100%)',
            color: '#333',
            minHeight: '100vh',
            padding: '30px',
        },
        header: {
            textAlign: 'center',
            color: '#000',
            marginBottom: '20px',
        },
        searchContainer: {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '20px',
        },
        searchInput: {
            width: '60%',
            height: '50px',
            borderRadius: '25px 0 0 25px',
            border: '1px solid #000',
            padding: '10px 20px',
            fontSize: '16px',
        },
        searchButton: {
            height: '50px',
            borderRadius: '0 25px 25px 0',
            backgroundColor: '#333',
            border: 'none',
            padding: '0 20px',
        },
        faqContainer: {
            maxWidth: '800px',
            margin: '0 auto',
        },
        faqCard: {
            background: '#fff',
            borderRadius: '8px',
            marginBottom: '10px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.15)',
            overflow: 'hidden',
            transition: 'transform 0.2s ease',
        },
        faqHeader: {
            backgroundColor: '#f8f9fa',
            padding: '10px 20px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        panelTitle: {
            margin: '0',
            fontSize: '18px',
            color: '#333',
        },
        icon: {
            fontSize: '1.4em',
            color: 'rgba(215, 201, 161, 1)',
            paddingRight: '10px'
        },
        panelBody: {
            padding: '15px 35px',
            fontSize: '16px',
            color: '#666',
            backgroundColor: '#fff',
        },
    };

    const [appContent, setAppContent] = useState([]);
    
    useEffect(() => {
        async function getAppData() {
            const contentReq = {}
            const response = await getAppFAQs(contentReq);
            if (parseInt(response.code) === 1) {
                setAppContent(response.data);
            } else {
                showErrorMessage(response.message);
            }
        }
        getAppData();
    }, []);

    const [searchTerm, setSearchTerm] = useState("");
    const [expandedPanels, setExpandedPanels] = useState({});

    const handleCollapse = (key) => {
        setExpandedPanels((prevExpanded) => ({
        ...prevExpanded,
        [key]: !prevExpanded[key]
        }));
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const filteredFaqs = appContent.filter((faq) =>
        faq.question.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            <div style={styles.pageContainer}>
                <head>
                    <title>Alchemy Markets - FAQ's</title>
                    <link rel="icon" href={process.env.PUBLIC_URL + "/logo.png"} type="image/x-icon" />
                </head>
                
                <div style={styles.header}>
                    <h1>FAQs</h1>
                    <p>Find answers to common questions below</p>
                </div>
                
                <div style={styles.searchContainer}>
                    <input
                    id="myInput"
                    value={searchTerm}
                    placeholder="Search your question..."
                    onChange={handleSearchChange}
                    className="form-control"
                    type="text"
                    style={styles.searchInput}
                    />
                    <button className="btn" style={styles.searchButton}>
                        <i className="zmdi zmdi-search" style={{ fontSize: "1.8em", color: "#fff" }}></i>
                    </button>
                </div>

                <div className="panel-group" id="accordion_10" role="tablist" aria-multiselectable="false" style={styles.faqContainer}>
                    {filteredFaqs.map((faq, key) => (
                        <div key={key} className="panel" onClick={() => handleCollapse(key)} style={styles.faqCard}>
                            <div className="panel-heading" role="tab" id={`headingOne_${key}`} style={styles.faqHeader}>
                                <h4 className="panel-title" style={styles.panelTitle}>
                                    <a role="button" href={`#collapseOne_${key}`} aria-expanded="true" aria-controls={`collapseOne_${key}`}>
                                        <i className={`zmdi ${expandedPanels[key] ? "zmdi-minus-square" : "zmdi-plus-square"}`} style={styles.icon}></i>
                                        {`${key + 1}. ${faq.question}`}
                                    </a>
                                </h4>
                            </div>
                            {expandedPanels[key] && (
                                <div id={`collapseOne_${key}`} className="panel-collapse collapse in" role="tabpanel" aria-labelledby={`headingOne_${key}`} style={{ display: expandedPanels[key] ? 'block' : 'none', transition: 'height 2.5s ease', overflow: 'hidden'}}>
                                    <div className="panel-body" style={styles.panelBody}>
                                        {faq.answer}
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}